import { Compass, Camera, Map, Users, Flame, ShieldCheck } from "lucide-react";

const OUTCOMES = [
  {
    icon: Compass,
    title: "Business Clarity",
    desc: "Clearer direction, offers and strategy.",
  },
  {
    icon: Camera,
    title: "Professional Content",
    desc: "Photos, clips and personal brand assets to take home.",
  },
  {
    icon: Map,
    title: "Execution Plan",
    desc: "A personalised roadmap for your next 30 days.",
  },
  {
    icon: Users,
    title: "Networking & Community",
    desc: "Real connections with ambitious people building too.",
  },
  {
    icon: Flame,
    title: "Momentum & Confidence",
    desc: "Real progress instead of more overthinking.",
  },
  {
    icon: ShieldCheck,
    title: "30 Days Accountability",
    desc: "Private follow-up support after the event.",
    highlight: true,
  },
];

export const LeaveWith = () => {
  return (
    <section
      id="outcomes"
      data-testid="buildday-outcomes-section"
      className="relative bg-[#0E0F12] py-24 md:py-40 border-t border-zinc-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16 md:mb-20">
          <div className="reveal flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#FCD34D]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#FCD34D] font-bold">
              What You Leave With
            </span>
          </div>
          <h2
            data-testid="buildday-outcomes-headline"
            className="reveal text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-extrabold text-white leading-[1.02]"
          >
            Leave with more than{" "}
            <span className="italic font-light text-white">motivation.</span>
          </h2>
          <p className="reveal mt-6 max-w-xl text-base md:text-lg leading-relaxed text-zinc-300 font-medium">
            Every block is built to give you something tangible to walk out
            with — assets, decisions, a plan and the people to keep you moving
            long after the day ends.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-zinc-800 border border-zinc-800">
          {OUTCOMES.map((o, i) => {
            const Icon = o.icon;
            return (
              <div
                key={i}
                data-testid={`buildday-outcome-${i + 1}`}
                className="reveal group relative bg-[#15161B] hover:bg-[#1A1B22] transition-colors duration-500 p-8 md:p-10"
              >
                <div className="flex items-start justify-between mb-10">
                  <span
                    className={`inline-flex items-center justify-center w-12 h-12 border transition-colors duration-300 ${
                      o.highlight
                        ? "border-[#FCD34D]/40 bg-[#FCD34D]/5"
                        : "border-zinc-800 bg-transparent group-hover:border-zinc-700"
                    }`}
                  >
                    <Icon
                      className={`w-5 h-5 ${
                        o.highlight ? "text-[#FCD34D]" : "text-zinc-400 group-hover:text-white"
                      } transition-colors duration-300`}
                      strokeWidth={1.4}
                    />
                  </span>
                  <span className="text-[10px] tracking-[0.3em] uppercase text-zinc-700 font-bold">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="text-xl md:text-2xl tracking-tight font-bold text-white mb-3 leading-tight">
                  {o.title}
                </h3>
                <p className="text-sm md:text-base text-zinc-300 leading-relaxed max-w-md">
                  {o.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
